import { Injectable } from '@angular/core';
import { Argus } from '../../models/argus';

@Injectable({
  providedIn: 'root'
})
export class ArgusDataService {

  private data: Argus[] = [];

  setData(value: Argus) {
    this.data?.push(value);
  }

  getData(activitynumber: string | null | undefined): Argus {
    var argusData = this.data?.filter((a: Argus) => a.Common?.ActivityNumber === activitynumber);
    return argusData?.length > 0 ? argusData[0] : {};
  }

  hasData(activitynumber: string | null | undefined): boolean {
    var argusData = this.data?.filter((a: Argus) => a.Common?.ActivityNumber === activitynumber);
    return argusData?.length > 0;
  }
}
